import OrderHistories from '../../../components/pages/mypages/OrderHistories'
export default {
  components: { OrderHistories }
}
